import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useConfigStore = defineStore('config', () => {
  // State
  const ctxOfLastAction = ref<any>(null);
  const rawMenu = ref<any[]>([]);

  // Getters
  const getCtxOfLastAction = computed(() => ctxOfLastAction.value);

  // Actions
  const setCtxOfLastAction = (ctx: any) => {
    ctxOfLastAction.value = ctx;
  };

  const clearCtxOfLastAction = () => {
    ctxOfLastAction.value = null;
  };

  const setRawMenu = (menu: any[]) => {
    rawMenu.value = menu;
  };

  return {
    // State
    ctxOfLastAction,
    rawMenu,

    // Getters
    getCtxOfLastAction,

    // Actions
    setCtxOfLastAction,
    clearCtxOfLastAction,
    setRawMenu,
  };
});
